// Sentry DSN çözümleme — tek kaynak, sıfır bağımlılık.
//
// Burası client + server + edge'de güvenle import edilir:
// - `@sentry/nextjs` YOK (SDK init/config dosyalarında yapılır)
// - `node:*` YOK, `posthog-node` YOK, `@/lib/log` YOK
// Client graph'a giren her dosya ya burayı ya da `sentry-client.ts`'i
// kullanmalı; ASLA `sentry.ts`'i (server-only, posthog-node içerir) import
// etmemeli — yoksa Turbopack client chunk'ta `node:fs` ile patlar:
// "the chunking context does not support external modules (node:fs)".

/**
 * Yerleşik proje DSN'i (public key — client bundle'a girmek üzere tasarlanmış).
 * Server/edge config'lerdeki fallback ile AYNI değer (tek kaynak burası).
 * ENV her zaman önceliklidir; bu yalnızca geriye uyumluluk emniyet supabıdır.
 *
 * NOT (TR engeli): `ingest.us.sentry.io` Türkiye çıkışlı ağlarda BTK
 * engellidir — yerel dev'den doğrudan gönderim ISS engel sayfasına düşer
 * (SDK sessizce kuyruklar, site etkilenmez). Üretim (self-host, TR çıkışlı) + tarayıcı
 * trafiği `tunnelRoute: /monitoring` üzerinden sorunsuz ulaşır; doğrulama
 * prod'da Issues ekranından yapılır.
 */
export const SENTRY_FALLBACK_DSN =
  "https://4358d6d977f5eb5568c951717d84be39@o395706.ingest.us.sentry.io/4512114813566976";

/** Server/edge SDK init + hasSentry ile aynı öncelik: ENV > ENV(public) > yerleşik. */
export function resolveSentryDsn(): string | null {
  const env = process.env.SENTRY_DSN?.trim() || process.env.NEXT_PUBLIC_SENTRY_DSN?.trim();
  return env || SENTRY_FALLBACK_DSN;
}

export function hasSentry(): boolean {
  // SDK server/edge'de fallback ile her zaman init olur — sinyal de aynı
  // çözümlemeyi kullanır (ENV yokken false-negative kalmaz).
  return !!resolveSentryDsn();
}
